import { __assign, __decorate, __extends, __metadata, __rest } from "tslib";
import React from 'react';
import { observer } from 'mobx-react';
import Button from '../Button';
import { FileContext } from './FileContext';
import FileBasicInput from './FileBasicInput';
var FileUploadButton = /** @class */ (function (_super) {
    __extends(FileUploadButton, _super);
    function FileUploadButton(props) {
        var _this = _super.call(this, props) || this;
        _this.fileInputRef = React.createRef();
        _this.browseButtonClicked = _this.browseButtonClicked.bind(_this);
        return _this;
    }
    FileUploadButton.prototype.browseButtonClicked = function (e) {
        if (this.fileInputRef.current) {
            this.fileInputRef.current.click();
        }
    };
    FileUploadButton.prototype.render = function () {
        var _a = this.props, fileManager = _a.fileManager, buttonProps = __rest(_a, ["fileManager"]);
        if (this.context.fileManager) {
            this.fileManager = this.context.fileManager;
        }
        else {
            if (!fileManager) {
                throw Error("File upload button must be in a FileContext, or have fileManager specified.");
            }
            this.fileManager = fileManager;
        }
        if (!buttonProps)
            buttonProps = {};
        if (!buttonProps.variant)
            buttonProps.variant = "light";
        if (this.fileManager.isUploading && !this.fileManager.options.allowConcurrent) {
            buttonProps.disabled = true;
        }
        return (React.createElement(React.Fragment, null,
            React.createElement(Button, __assign({}, buttonProps, { onClick: this.browseButtonClicked }), this.props.children),
            React.createElement(FileBasicInput, { fileManager: this.fileManager, isHidden: true, inputRef: this.fileInputRef })));
    };
    FileUploadButton.contextType = FileContext;
    FileUploadButton = __decorate([
        observer,
        __metadata("design:paramtypes", [Object])
    ], FileUploadButton);
    return FileUploadButton;
}(React.Component));
export default FileUploadButton;
